import { useGlobalStore } from '@/stores/global'
import API from '@/services'
import type { MosaicLatest } from '@/types'

/**
 * Composable para manejar la carga y gestión de mosaicos
 */
export function useMosaics() {
  const globals = useGlobalStore()

  /**
   * Carga las fotos de un mosaico específico
   * @param mosaicId - ID del mosaico
   */
  async function loadMosaicPhotos(mosaicId: number) {
    try {
      const response = await API.listMosaicPhotos(mosaicId)
      const photos = response.data.Entries.Entry || []
      globals.addMosaicPhotos(mosaicId, photos)
      console.log(`Cargadas ${photos.length} fotos del mosaico ${mosaicId}`)
    } catch (error) {
      console.error('Error cargando fotos del mosaico:', error)
      globals.addMosaicPhotos(mosaicId, [])
    }
  }
  /**
   * Carga las fotos de un mosaico específico
   * @param mosaicId - ID del mosaico
   */
  async function loadHMosaicPhotos(mosaicId: number) {
    try {
      const response = await API.listMosaicPhotos(mosaicId)
      const photos = response.data.Entries.Entry || []
      console.log(`Cargadas ${photos.length} fotos del mosaico ${mosaicId}`)
      return photos
    } catch (error) {
      console.error('Error cargando fotos del mosaico:', error)
      return []
    }
  }
  /**
   * Carga los mosaicos más recientes en las últimas horas especificadas
   * @param hours - Número de horas hacia atrás para buscar mosaicos
   * @param bounds - Opcional: límites del mapa para filtrar mosaicos por área
   */
  async function loadLatestMosaics(
    hours: number,
    bounds?: { min_lon: number; min_lat: number; max_lon: number; max_lat: number }
  ) {
    try {
      // Si no se proporcionan límites, usar valores por defecto que cubran un área amplia
      const min_lon = bounds?.min_lon ?? -180
      const min_lat = bounds?.min_lat ?? -90
      const max_lon = bounds?.max_lon ?? 180
      const max_lat = bounds?.max_lat ?? 90

      const response = await API.listLatestMosaics(hours, min_lon, min_lat, max_lon, max_lat)
      const mosaics: MosaicLatest[] = response.data.Entries.Entry || []
      globals.setLatestMosaics(mosaics)
      console.log(`Cargados ${mosaics.length} mosaicos recientes`)

      // Cargar fotos de cada mosaico
      for (const mosaic of mosaics) {
        await loadMosaicPhotos(mosaic.mosaic_id)
      }
    } catch (error) {
      console.error('Error cargando mosaicos recientes:', error)
      globals.setLatestMosaics([])
    }
  }

  /**
   * Obtiene las fotos de un mosaico específico
   * @param mosaicId - ID del mosaico
   * @returns Array de fotos del mosaico
   */
  function getMosaicPhotos(mosaicId: number): any[] {
    return globals.getMosaicPhotos(mosaicId)
  }

  /**
   * Actualiza los mosaicos periódicamente
   * @param hours - Número de horas hacia atrás para buscar mosaicos (por defecto 120)
   * @param bounds - Opcional: límites del mapa para filtrar mosaicos por área
   */
  async function updateMosaics(
    hours: number = 120,
    bounds?: { min_lon: number; min_lat: number; max_lon: number; max_lat: number }
  ) {
    await loadLatestMosaics(hours, bounds)
  }

  return {
    loadLatestMosaics,
    loadMosaicPhotos,
    loadHMosaicPhotos,
    getMosaicPhotos,
    updateMosaics
  }
}
